import { useLocation } from "react-router";

import { unsafelyFromEntries } from "common/utilities/object";

export const useQueryParams = (): Partial<Record<string, string>> =>
  unsafelyFromEntries(new URLSearchParams(useLocation().search));
